/** `GET payments/upcoming/` — status OPEN/PARTIAL, due today or later. */
import { getUpcomingPayments } from '../../api/endpoints/payments';
import { PaymentFeedPage } from './PaymentFeedPage';

export function UpcomingPaymentsPage(): React.JSX.Element {
  return (
    <PaymentFeedPage
      title="Upcoming payments"
      queryKey="payments-upcoming"
      queryFn={getUpcomingPayments}
      emptyMessage="No upcoming payments."
    />
  );
}

export default UpcomingPaymentsPage;
